import { Component, inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DashboardDialogFramePart, DialogAction, DialogContext } from '@eforall/dashboard';
import { AddDashboardDialogService } from '../add-dashboard.dialog.service';
import { AddDashboardStep1Part } from '../step-1/add-dashboard-step-1.part';
import { AddDashboardStep2Part } from '../step-2/add-dashboard-step-2.part';
import { AddDashboardStep3Part } from '../step-3/add-dashboard-step-3.part';


@Component({
	selector: 'add-dashboard-dialog',
	standalone: true,
	imports: [
		DashboardDialogFramePart,
		AddDashboardStep1Part,
		AddDashboardStep2Part,
		AddDashboardStep3Part,
	],
	templateUrl: './add-dashboard.dialog.html',
	styleUrl: './add-dashboard.dialog.scss',
})

export class AddDashboardDialog {

	public dialogRef = inject(MatDialogRef<AddDashboardDialog>);
	public dialogContext: DialogContext<{}> = inject(MAT_DIALOG_DATA);
	public service = inject(AddDashboardDialogService);


	public actions: DialogAction[] = [
		{
			id: 'add',
			cssClass: signal('btn-primary'),
			enabled: this.service.readyToAdd,
			visible: signal(true),
			text: signal('Add Dashboard'),
			linkType: 'no-action',
			willCloseDialog: true,
		},
		{
			id: 'cancel',
			cssClass: signal(undefined),
			enabled: signal(true),
			visible: signal(true),
			text: signal('Cancel'),
			linkType: 'no-action',
			willCloseDialog: true,
		},
	];


}